export default class MessageCollection {
  public messages: Record<string, string[]>;

  constructor(messages = {}) {
    this.messages = messages;
  }

  add(fieldName: string, message: string) {
    if (!(fieldName in this.messages)) {
      this.messages[fieldName] = [];
    }
    if (this.messages[fieldName].length === 0) {
      this.messages[fieldName].push(message);
    }
  }

  has(fieldName: string) {
    return fieldName in this.messages && this.messages[fieldName].length > 0;
  }

  get(fieldName: string): string[] {
    if (this.has(fieldName)) {
      return this.messages[fieldName];
    }
    return [];
  }

  first(fieldName: string): string | null {
    if (this.has(fieldName)) {
      return this.messages[fieldName][0];
    }
    return null;
  }

  get length() {
    let count = 0;
    Object.keys(this.messages).forEach((key) => {
      count += this.messages[key].length;
    });
    return count;
  }

  concat(messageCollection: MessageCollection) {
    Object.keys(messageCollection.messages).forEach((key) => {
      this.messages[key] = messageCollection.messages[key];
    });
  }

  clear() {
    this.messages = {};
  }
}
